import React from 'react';

import StandardModal from '../../Shared/UI/StandardModal/components/StandardModal';
import Divider from '../../Shared/UI/Divider/components/Divider';
import PageTitle from '../../Shared/UI/PageTitle/components/PageTitle';
import NewUnrecognizedInterestFormForModal from './NewUnrecognizedInterestFormForModal';
import CircleLoader from '../../Shared/UI/CircleLoader/components/CircleLoader';
import InterestsModalTable from './InterestsModalTable';
import InterestsModalPageController from './InterestsModalPageController';

import { useProfileState, useProfileActions } from './ProfileContext';

const InterestsModal = () => {
  const profileState = useProfileState();
  const { closeUserInterestsModal } = useProfileActions();

  const hasInterestsFromApi = profileState.interestsModal?.interests?.length > 0;

  const mainModalContent = profileState.interestsModal.loading ? (
    <CircleLoader />
  ) : (
    <>
      <InterestsModalTable />
      {hasInterestsFromApi && <InterestsModalPageController />}
    </>
  );

  return (
    <StandardModal
      isOpen={profileState.userInterestsModalIsOpen}
      contentLabel={'Update Your Interests'}
      onRequestClose={() => {
        closeUserInterestsModal();
      }}
    >
      <PageTitle text={'Interests'} />
      <NewUnrecognizedInterestFormForModal />
      <Divider />
      {mainModalContent}
    </StandardModal>
  );
};

export default InterestsModal;
